export const sliceId = 'reactiveDualTransPage';
